<template>
    <div style="height:100%">
        <div style="background:#f1cdd7;width:514px;height:100%;float:left;">
            <div style="padding:64px 30px 64px 64px;height:261.5px">
                <a  @click="to('/index')" class="logo">
                    <b>店无忧</b>
                </a>
                <b class="nb" >精于心，简于形</b>
            </div>
            <div v-bind:style="'height:'+imgHeight+'px;max-height:601px;min-height:487px;margin-top:'+imgTop+'px'">
                <div :style="bg" ></div>
            </div>
        </div>
        <div style="overflow: hidden; ">
            <div style="height:50px;padding:15px 30px 0;text-align:right">
                <p>没有账号？
                    <a style="color:#4f3cc9"  @click="to('/register')">去注册</a>
                </p>
            </div>
            <div :style="'padding-top:'+mainTop+'px'">
                <div style="padding:30px 60px 0;margin:auto;width:536px">
                <div>
                    <h2>找回密码</h2>
                    <a-divider style="margin-top:40px">Or</a-divider>
                    <div style="margin-bottom:12px">
                         <label>手机号</label>
                        <input v-model="phone" type="text" autocomplete="new-password"  tabindex="1" class="text-input" autocorrect="off" autocapitalize="off">
                    </div>
                    <div style="margin-bottom:12px">
                         <label>验证码</label>
                        <input v-model="smsCode" type="text" autocomplete="new-password" style="width:300px"  tabindex="2" class="text-input" autocorrect="off" autocapitalize="off">
                        <a-button @click="sendSms" class="sendBtn" :disabled="secods>0" >
                            <template #icon ><MailOutlined /></template>
                            {{secods>0?secods+' s':'发送'}}
                        </a-button>
                    </div>

                    <div style="margin-bottom:12px">
                         <label>新密码 </label>
                        <input type="password" v-model="password" autocomplete="new-password"  tabindex="3" class="text-input" autocorrect="off" autocapitalize="off">
                    </div>
                    <a-button @click="recover"  class="loginBtn">
                        确定
                    </a-button>
                    <!-- <input class="loginBtn" :disabled="false" type="button" value="注册" tabindex="3"> -->
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MailOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

import {sendSmsRecover,loginWithCode} from '@/request.js'
const phoneReg = /^1[3-9]\d{9}$/
export default {
   name: '',
    components:{MailOutlined},
    data() {
        return {
            secods:0,
            phone:"",
            password:"",
            smsCode:"",
            imgTop:0,
            mainTop:0,
            imgHeight:0,
            bg:{
                backgroundImage:'url(' + require('../assets/test.jpg') + ')',
                width:'100%',
                height:'100%',
                backgroundRepeat:"no-repeat",
                backgroundPosition:"bottom center",
                backgroundSize:"cover",
                flexGrow:1,
            },
        };
    },
    methods: {
        to(path){
            this.$router.push(path)
        },
        recover(){
            if(!phoneReg.test(this.phone)){
                message.warning("请填写正确的手机号");
            }
            else if(this.smsCode==null||this.smsCode.length!=4){
                message.warning("请填写短信验证码");
            }
            else if(this.password==null||this.password.length==0){
                message.warning("请填写密码");
            }else{
                loginWithCode({
                    phone:this.phone,
                    loginPwd:this.password,
                    captcha:this.smsCode,
                },(res)=>{
                    if(res.IsSuccess){
                        localStorage.setItem("token",res.Message);
                        localStorage.setItem("phone",this.phone);
                        this.to("/index");
                    }else{
                        message.error(res.Message);
                    }
                })
            }
        },
        sendSms(){
            if (!phoneReg.test(this.phone)){
                message.warning("请填写正确的手机号");
            }else{
                sendSmsRecover({
                    phone:this.phone
                },(res)=>{
                    if(res.IsSuccess){
                        this.secods=60;
                        let timer=setInterval(() => {
                            if(this.secods==0){
                                clearInterval(timer);
                            }else{
                                this.secods-=1;
                            }
                        }, 1000);
                    }else{
                         message.error(res.Message);
                    }
                })
            }
        }
    },
    created(){
        this.imgHeight=document.documentElement.clientHeight-336
        this.imgTop=(document.documentElement.clientHeight-862.5)/2-20;
        this.mainTop=parseInt(document.documentElement.clientHeight/4);
    },
    mounted() {
        window.onresize = () => {
            return (() => {
                this.imgHeight=document.documentElement.clientHeight-336;
                this.imgTop=(document.documentElement.clientHeight-862.5)/2-20;
                this.mainTop=parseInt(document.documentElement.clientHeight/4);
            })()
        }
    }
};
</script>
<style scoped>
.sendBtn{
    height:38px;float:right
}
.sendBtn:focus{
    color: #ea4c89;
    border-color: #f082ac;
}
.sendBtn:hover {
    color: #ea4c89;
    border-color: #f082ac;
} 

.wechat{
    color:#6e6d7a;background-color:#f2f2f2;padding: 10px 16px;border: none;cursor: pointer;border-radius: 8px;opacity: 0.7;margin-left:270px
}
.wechat:hover{
    opacity: 1;
}
label{
        display: block;
    font: bold 15px/24px "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin: 14px 0 4px;
    color: #0d0c22;
}
label a {
    font-weight: normal;
    float: right;
    position: relative;
    font-size: 14px;
}
h2{
    font: bold 24px/29px "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin-bottom: 26px;
}
.nb{
  font-family:"Times New Roman",Georgia,Serif;
    color:#865c6c;font-size:45px;
}
.logo:hover{
    opacity: 1;
}
.logo{
    letter-spacing:2px;
    display: block;
    margin-bottom: 30px;
    opacity: 0.7;
    color: inherit;
    text-decoration: underline;
    color:rgb(134, 92, 108);
    text-decoration:none; 
    font-size: 26px;
}
</style>